module.exports = __webpack_public_path__ + "media/images/sale_crm/invoice-378310a8abaf58849b0cff6b4b7317f8.svg";